import React from 'react'
import { Button, Container, Table } from 'react-bootstrap';
import styles from './Measures.module.scss';
import { data } from '../data';

const PQICodeLog = () => {

    return (<>

<Container className='outerContainer'>
            <h1 className="centerText mb-5">PQI Log of Coding Updates and Revisions</h1>
            <p className="mb-5">This page provides information on the revisions made to the PQI software, coding, software documentation, and technical specifications in Version v2021, July 2021.</p>
            <Table className={styles.codetable} striped>
                <tbody >
                    {data.codelog.map((information, index) => (<>
                        {information.PQI.map((info, index) => (<>
                            <tr >
                                <td><h3>{info.title}</h3>
                                    <p>{info.desc}</p>
                                    <p><Button href={info.url}>{info.cta}</Button></p>
                                </td>
                            </tr>
                        </>))}
                    </>))}
                </tbody>
            </Table>
        </Container>
    </>)
}

export default PQICodeLog;